export type AppConfig = {
  stage: Stage;
  mapsApiKey: string;
};

export enum Stage {
  LIVE = 1,
  TEST = 2,
  DEV = 3,
}
